import { createTheme } from '@mui/material/styles';
import { indigo, red } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: indigo,
    secondary: red,
  },
});
